import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchPreviewUser } from '../../../actions/Users/UserAction';
import { impersonateUserStart } from '../../../actions/Users/ImpersonateAction';
import Api from '../../../Api';
import { onErrorMsg, onSuccessMsg } from '../../../actions/FlashMessage/FlashMessages';
import CasOrgsTabel from '../../Common/Tabel/CasOrgsTabel';
import { ASSOCIATION_USER, SUPER_USER } from '../../../actionTypes/Users/UserActionType';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';
import CasTable from '../../Common/Tabel/CasTable';
import { ModalContainer } from '../../Common';
import { canEditUserRole, canImpersonate, canRemoveUserRole } from '../../../utils/permissions';
import { compareIgnoreCase } from '../../../utils/helpers';
import withNavigate from '../../HOC/navigate';

class AdminUserMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteModal: false,
      disableModal: false,
      guid: '',
      loggedAs: '',
    };
  }

  showDeleteModal() {
    this.setState({ deleteModal: true });
  }

  hideDeleteModal() {
    this.setState({ deleteModal: false });
  }

  showDisableModal() {
    this.setState({ disableModal: true });
  }

  hideDisableModal() {
    this.setState({ disableModal: false });
  }

  async deleteUser() {
    try {
      const { previewUser } = this.props;
      const api = new Api();
      await api.delData(`/rest/users/${previewUser.id}`);
      this.hideDeleteModal();
      this.props.navigate('/users', { statusMessage: `${previewUser.email} has been successfully removed.` });
    } catch (error) {
      this.hideDeleteModal();
      const errorMsg = error.response ? error.response.data.error : '';
      this.props.onErrorMsg(errorMsg);
    }
  }

  async disableUser() {
    try {
      const { previewUser } = this.props;
      const api = new Api();
      await api.putData(`/rest/users/${previewUser.id}/disable`);
      await this.props.fetchPreviewUser(previewUser.guid);
      // TODO: temporary solution to show message on the Layout after we move to the users list
      setTimeout(() => {
        this.props.onSuccessMsg(`${previewUser.email} has been successfully disabled.`);
      }, 0);
      this.hideDisableModal();
    } catch (error) {
      this.hideDisableModal();
      const errorMsg = error.response ? error.response.data.error : '';
      this.props.onErrorMsg(errorMsg);
    }
  }

  printTableByRole() {
    const { casOrgs, userRoleConstant } = this.props.previewUser;

    if (userRoleConstant === ASSOCIATION_USER) {
      return <CasTable casOrganizations={casOrgs} />;
    } else {
      return <CasOrgsTabel casOrganizations={casOrgs} />;
    }
  }

  impersonate() {
    this.setState({ load: false });
    this.props.impersonateUserStart();
  }

  render() {
    let { previewUser } = this.props;
    const options = this.visibleOptionsList();

    if (!previewUser.guid || !options.length) {
      return null;
    }

    return (
      <React.Fragment>
        <UncontrolledButtonDropdown data-testid="dropdown-btn" className="main-nav__dropdown user-details-dd">
          <DropdownToggle className={'main-nav__dropdown__btn '} size="lg" caret />
          <DropdownMenu>
            {options.includes('enable') && (
              <DropdownItem
                tag="button"
                onClick={() => {
                  this.props.navigate(`/editUser?guid=${previewUser.guid}&isEnable=true`);
                }}
                className={'ref-blue'}>
                Enable
              </DropdownItem>
            )}

            {options.includes('edit') && (
              <DropdownItem
                tag="button"
                onClick={() => {
                  this.props.navigate(`/editUser?guid=${previewUser.guid}`);
                }}
                className={'ref-blue'}>
                Edit
              </DropdownItem>
            )}

            {options.includes('impersonate') && (
              <DropdownItem
                disabled={!!this.props.userPersonated}
                onClick={(e) => this.impersonate(e)}
                tag="button"
                className={'ref-blue'}>
                Impersonate
              </DropdownItem>
            )}

            {options.includes('disabled') && (
              <DropdownItem tag="button" onClick={this.showDisableModal.bind(this)} className={'btn-link-danger'}>
                Disable
              </DropdownItem>
            )}
            {options.includes('remove') && (
              <DropdownItem tag="button" onClick={this.showDeleteModal.bind(this)} className={'btn-link-danger'}>
                Remove
              </DropdownItem>
            )}
          </DropdownMenu>
        </UncontrolledButtonDropdown>

        {this.state.disableModal && (
          <ModalContainer
            size="small"
            isOpen={this.state.disableModal}
            btnSubmitText={'Disable User'}
            onSubmit={this.disableUser.bind(this)}
            onCancel={this.hideDisableModal.bind(this)}
            title={'Disable User'}
            text={
              <span>
                Disabling will prevent <b>{this.props.previewUser.email}</b> from accessing Analytics by Liaison and all
                permission will be removed. You may not edit or impersonate disabled users.
              </span>
            }
          />
        )}

        {this.state.deleteModal && (
          <ModalContainer
            isOpen={this.state.deleteModal}
            btnSubmitText={'Remove User'}
            onSubmit={this.deleteUser.bind(this)}
            onCancel={this.hideDeleteModal.bind(this)}
            title="Remove User"
            text={
              <React.Fragment>
                <span className={'show'}>
                  Would you like to remove <b>{this.props.previewUser.email}</b> from your team?
                </span>
                <span>This will remove access to the following Organizations:</span>
                <div style={{ margin: '0 20px' }}>{this.printTableByRole()}</div>
              </React.Fragment>
            }
          />
        )}
      </React.Fragment>
    );
  }

  checkAssocAndAdminUserAccess(loggedUserRole, previewUserRole) {
    const { loggedUserDetails } = this.props;

    if (
      [ASSOCIATION_USER].includes(loggedUserRole) &&
      compareIgnoreCase(loggedUserDetails.userManagementAccess, 'True')
    ) {
      return true;
    } else return false;
    /* else if([ASSOCIATION_USER].includes(loggedUserRole) && [ADMINISTRATOR_USER, REPORT_USER].includes(previewUserRole)){
      return true
    }
    else if([ADMINISTRATOR_USER].includes(loggedUserRole) && [REPORT_USER].includes(previewUserRole)){
      return true
    }*/
  }

  visibleOptionsList() {
    const { previewUser, loggedUserDetails } = this.props;
    const loggedUserRole = loggedUserDetails.userRole;
    const previewUserRole = previewUser?.userRoleConstant;
    const allowEdit = canEditUserRole(loggedUserRole, previewUserRole);
    const allowRemove = canRemoveUserRole(loggedUserRole, previewUserRole);
    const allowImpersonate = canImpersonate(loggedUserRole, previewUserRole);
    const notActivated = previewUser?.source === 'I';
    const { disabled } = previewUser;
    const options = [];

    if (allowImpersonate && previewUser.source === 'U' && !disabled) {
      options.push('impersonate');
    }

    if (!notActivated) {
      if (loggedUserRole === SUPER_USER) {
        options.push(disabled ? 'enable' : 'disabled');
      } else if (this.checkAssocAndAdminUserAccess(loggedUserRole, previewUserRole)) {
        options.push(disabled ? 'enable' : 'disabled');
      } else if (allowRemove && !disabled) {
        options.push('remove');
      }
    }

    if (allowEdit && !disabled) {
      options.push('edit');
    }

    return options;
  }
}

function mapStateToProps(state) {
  return {
    userPersonated: state.Impersonate.impersonate.userPersonated,
    previewUser: state.Users.previewUser,
    loggedUserDetails: state.AppSession.userDetails,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      impersonateUserStart,
      fetchPreviewUser,
      onSuccessMsg,
      onErrorMsg,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(withNavigate(AdminUserMenu));
